import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', 'Mailboxes')
export const SEGMENTS_REQUEST_ASYNC = createAsyncTypes('SEGMENTS_REQUEST_ASYNC', 'Mailboxes')

export const AS_O365_ASYNC = createAsyncTypes('AS_O365_ASYNC', 'Mailboxes')
export const AS_GD_ASYNC = createAsyncTypes('AS_GD_ASYNC', 'Mailboxes')
